<nb-card class="nb_card_pop_up">
  <nb-card-header>
    <div class="title">
      <span i18n="@@NewGoal" *ngIf="!ID">New Goal</span>
      <span i18n="@@EditGoal" *ngIf="ID">Edit Goal</span>
    </div>
  </nb-card-header>

  <nb-card-body [formGroup]="GoalForm">

    <input style="visibility:hidden" formControlName="ID" />
    <input style="visibility:hidden" formControlName="PatientID" />

    <div>

      <div class="form-group row">
        <div i18n="@@GoalName" class="col-sm-4 label col-form-label">Goal Name</div>
        <div class="col-sm-8">
          <input nbInput formControlName="GoalName" [status]="(GoalName?.errors?.required || GoalName?.hasError('minlength') || GoalName?.hasError('maxlength')) ? 'danger' : 'primary'" type="text" fullWidth shape="semi-round"
            i18n-placeholder="@@GoalName" placeholder="{{GoalNameLabel}}">
          <ngx-validation-message i18n-label="@@GoalName" label="Goal Name"
                                  [showRequired]="GoalName?.errors?.required && GoalName.touched"
                                  min=1 max=200></ngx-validation-message>
        </div>
      </div>

      <div class="form-group row">
        <div i18n="@@TargetDate" class="col-sm-4 label col-form-label">Target Date</div>
        <div class="col-sm-8">
          <input [attr.disabled]="DisableDate === '1' ? '' : null" nbInput [status]="(targetDate?.errors?.required) ? 'danger' : 'primary'"
            i18n-placeholder="@@TargetDate" placeholder="Target Date" [nbDatepicker]="formpicker" formControlName="targetDate"> <nb-datepicker #formpicker></nb-datepicker>
          <ngx-validation-message
            i18n-label="@@TargetDate" label="Target Date" [showRequired]="targetDate?.errors?.required && targetDate.touched"></ngx-validation-message>
        </div>

      </div>

      <div class="form-group row">
        <div i18n="@@GoalType" class="col-sm-4 label col-form-label">Goal Type</div>
        <div class="col-sm-8">
          <nb-select formControlName="GoalType" fullWidth shape="semi-round"
                     [status]="(GoalType?.errors?.required || GoalType?.errors?.min || GoalType?.errors?.max || GoalType?.hasError('pattern')) ? 'danger' : 'primary'"
                     i18n-placeholder="@@GoalType" placeholder="Goal Type">
            <nb-option [value]="0">Body Fat %</nb-option>
            <nb-option [value]="1">BMI</nb-option>
            <nb-option [value]="2">Weight ({{Patient && Patient.isPreferredUnitImperial ? 'lbs':'kg'}})</nb-option>
          </nb-select>
          <ngx-validation-message i18n-label="@@GoalType" label="Goal Type"
                                  [showRequired]="GoalType?.errors?.required && GoalType.touched"
                                  [showMin]="GoalType?.errors?.min && GoalType.touched"
                                  [showMax]="GoalType?.errors?.max && GoalType.touched"
                                  [showPattern]="GoalType?.hasError('pattern')"></ngx-validation-message>
        </div>

      </div>

      <div class="form-group row">
        <div i18n="@@GoalValue" class="col-sm-4 label col-form-label">Goal Value</div>
        <div class="col-sm-8">
          <input nbInput formControlName="GoalValue"
            (keypress)="validateNumber($event)"
            [status]="(GoalValue?.errors?.required || GoalValue?.hasError('min') || GoalValue?.hasError('max')) ? 'danger' : 'primary'"
            type="text" fullWidth shape="semi-round"
              i18n-placeholder="@@GoalValue" placeholder="Goal Value">
          <ngx-validation-message i18n-label="@@GoalValue" label="Goal Value"
                                  [showRequired]="GoalValue?.errors?.required && GoalValue.touched"
                                  [showMin]="GoalValue?.errors?.min && GoalValue.touched"
                                  [showMax]="GoalValue?.errors?.max && GoalValue.touched"
                                  [showPattern]="GoalValue?.hasError('pattern')" min=1 [max]="GoalValueMax"></ngx-validation-message>
        </div>
      </div>

    </div>

  </nb-card-body>

  <nb-card-footer>
    <div class="actions float-left">
      <button i18n="@@Save" nbButton type="submit"  (click)="SaveGoal()" class="btn-circle btn-xl btn-main" [disabled]="!GoalForm.valid">Save</button>
      <button i18n="@@Back" nbButton type="button" status="basic" class="back btn-circle btn-xl" (click)="Back()">Back</button>
    </div>
  </nb-card-footer>


</nb-card>
